<div
  class="wrap"
  (click)="handleOpen()"
  (clickOutside)="handleClose()"
  [clickOutsideExcludeSelector]="'.currency-wallet-expansion'"
  [class.diasbled]="isDiasbled"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
>
  <ng-content select="[content]"></ng-content
  ><!--币种切换tab-->
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayLockPosition
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="expanded"
  [cdkConnectedOverlayPositions]="position"
  cdkConnectedOverlayFlexibleDimensions
>
  <div
    class="expansion-details currency-wallet-expansion"
    @expansion
    appLifeObserve
    (lifeChange)="!$event && handleClose()"
    [class]="size"
  >
    <div class="search-row" [class.disabled]="!currentCurrencyData" [class.pr-20]="hideSetting">
      <app-customize-input [leftIcon]="'icon-search'" [placeholder]="'search' | translate" [(value)]="keyword">
      </app-customize-input>
      <div class="btn-icon mutual-opacity" (click)="editCurrency()" *ngIf="!hideSetting">
        <i class="icon-add-del"></i>
      </div>
    </div>
    <div class="menu" [class.disabled]="!currentCurrencyData" *ngIf="!keyword">
      <mat-tab-group
        disableRipple="true"
        class="unit-mat-tab-group no-content"
        [selectedIndex]="selectIndex"
        (selectedIndexChange)="selectIndex !== $event && selectTab($event)"
      >
        <mat-tab [label]="'crypto' | translate"></mat-tab>
        <mat-tab [label]="'fiat_cur' | translate"></mat-tab>
      </mat-tab-group>
    </div>
    <app-scrollbar *ngIf="currentCurrencyData" [hostPosition]="'relative'">
      <div class="form-group" [appLoading]="!currentCurrencyData" [@toggle]="tabToggleAnimateTick">
        <!-- 正常tab -->
        <ng-container *ngIf="!keyword">
          <ng-container
            *ngTemplateOutlet="
              currencyList;
              context: {
                data:
                  currenciesList
                  | filterByKeyValue: 'isDigital' : selectIndex === 0
                  | filterByKeyValue: 'display' : true
              }
            "
          ></ng-container>
        </ng-container>
        <!-- 搜索时，不分数字或法币 -->
        <ng-container *ngIf="keyword">
          <ng-container
            *ngTemplateOutlet="
              currencyList;
              context: {
                data: currenciesList | filterByText: keyword : ['currency'] | filterByKeyValue: 'display' : true,
                otherData: currenciesList | filterByText: keyword : ['currency'] | filterByKeyValue: 'display' : false
              }
            "
          ></ng-container>
        </ng-container>
      </div>
    </app-scrollbar>
    <div class="expansion-footer" [class.disabled]="!currentCurrencyData" *ngIf="!hideBottom">
      <mat-slide-toggle
        class="unit-mat-slide-toggle"
        [checked]="(currencyWalletService.conversionCurrency$ | async)?.enable"
        (change)="showOnFait(showOnFiatPop, $event.checked)"
      >
        {{ 'view_in_f' | translate }}
      </mat-slide-toggle>
      <mat-slide-toggle class="unit-mat-slide-toggle" [(ngModel)]="hideSmall" (change)="initData()">
        {{ 'hide_small_t' | translate }}
      </mat-slide-toggle>
    </div>
  </div>
</ng-template>

<!-- 币种遍历列表 -->
<ng-template #currencyList let-data="data" let-otherData="otherData">
  <!-- 有数据 -->
  <ng-container *ngIf="data.length > 0 || otherData?.length > 0; else noData">
    <ng-container *ngFor="let item of data">
      <ng-container *ngTemplateOutlet="currencyItem; context: { item: item }"></ng-container>
    </ng-container>
    <!-- 其它（搜索可能有） -->
    <ng-container *ngIf="otherData?.length > 0">
      <div class="other-currency">{{ 'ser_other_curr_t' | translate }}</div>
      <ng-container *ngFor="let otherItem of otherData">
        <ng-container *ngTemplateOutlet="currencyItem; context: { item: otherItem, isOther: true }"></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <!-- 无数据 -->
  <ng-template #noData>
    <app-empty [text]="'search_unfind' | translate" [icon]="'assets/temp5/empty.png'"></app-empty>
  </ng-template>
</ng-template>

<!-- 币种栏 -->
<ng-template #currencyItem let-item="item" let-isOther="isOther">
  <div class="currency-item" [class.select]="item.currency === checkedItem" (click)="handleSelect(item, isOther)">
    <div class="left">
      <img [src]="item.icon" />
      <span>{{ item.currency }}</span>
      <!-- LED規則 -->
      <div class="led-rule" *ngIf="item.currency == 'LED'" (click)="$event.stopPropagation(); openLedPopup(true)">
        <i class="icon-warning"></i>
      </div>
      <div
        class="non-sticky led-rule"
        *ngIf="
          (allCurrencyBalance | filterByKeyValue: 'currency' : item.currency : 'isShowNonSticky') &&
          (allCurrencyBalance | filterByKeyValue: 'currency' : item.currency : 'nonStickyBalance') > 0
        "
        (click)="$event.stopPropagation(); showNonStickBalanceDetail(item.currency)"
      >
        <i class="icon-warning mutual-opacity"></i>
      </div>
    </div>
    <div class="right">
      <ng-container
        *ngTemplateOutlet="
          currencyItemRight;
          context: {
            conversionCurrencyData: currencyWalletService.conversionCurrency$ | async,
            item: item,
            balance: allCurrencyBalance | filterByKeyValue: 'currency' : item.currency : 'nonStickyBalance'
          }
        "
      ></ng-container>
    </div>
  </div>
</ng-template>

<!-- 币种栏右边 -->
<ng-template
  #currencyItemRight
  let-conversionCurrencyData="conversionCurrencyData"
  let-item="item"
  let-balance="balance"
>
  <div *ngIf="conversionCurrencyData.enable" class="conversion-value">
    <div class="skeleton-loading" *ngIf="conversionCurrencyData.loading"></div>
    <ng-container *ngIf="!conversionCurrencyData.loading && conversionCurrencyData.rate.length > 0">
      {{ conversionCurrencyData.currency.symbol }}
      {{
        currencyWalletService.amountAfterCalculateRate(balance, item.currency)
          | currencyValue: conversionCurrencyData.currency.currency
      }}
    </ng-container>
  </div>
  <div
    class="amount-value"
    [class.alone]="!conversionCurrencyData.enable"
    [class.hide]="conversionCurrencyData.enable && item.currency == 'LED'"
  >
    {{ balance | currencyValue: item.currency }}
  </div>
  <!-- LED不以法币显示 -->
  <div class="amount-value led" *ngIf="item.currency == 'LED'">
    <i class="icon-lock"></i>
    <span>{{ ledData?.unlockedAmount || 0 | currencyValue: item.currency }}</span>
  </div>
</ng-template>

<!-- 顶部币值显示 -->
<ng-template
  #topAmountValue
  let-conversionCurrencyData="conversionCurrencyData"
  let-currency="currency"
  let-balance="balance"
>
  <ng-container *ngIf="conversionCurrencyData.enable">
    <ng-container>
      {{ conversionCurrencyData?.currency?.symbol || '' }}
      {{
        conversionCurrencyData?.rate?.length > 0
          ? (currencyWalletService.amountAfterCalculateRate(balance, currency)
            | currencyValue: conversionCurrencyData?.currency?.currency || 'USDT')
          : '0.00'
      }}
    </ng-container>
  </ng-container>
  <ng-container *ngIf="!conversionCurrencyData.enable">
    {{ balance | currencyValue: currency }}
  </ng-container>
</ng-template>

<!-- 选择显示换算的法币弹窗 -->
<ng-template #showOnFiatPop>
  <div class="show-on-fiat-box currency-wallet-expansion">
    <div class="content">
      <div class="title">
        <span>{{ 'curr_cho' | translate }}</span>
      </div>
      <div class="content-desc">
        <div class="desc">{{ 'vif_top_desc' | translate }}</div>
      </div>
      <div class="currency-select-box">
        <div class="currency-grid">
          <div *ngFor="let item of currencies | filterByKeyValue: 'isDigital' : false" class="currency-select-item">
            <mat-radio-button
              [checked]="item.currency === (currencyWalletService.conversionCurrency$ | async)?.currency?.currency"
              (change)="selectShowOnFiat(item)"
            >
              <div class="currency-select-content">
                <span class="currency-select-text">{{ item.currency }}</span>
                <img class="currency-select-img" [src]="item.icon" />
              </div>
            </mat-radio-button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <customize-button
        size="large-medium"
        type="primary-linear"
        width="100%"
        maxWidth="240px"
        (onClick)="showOnFaitPop.close()"
      >
        {{ 'confirm_button' | translate }}
      </customize-button>
    </div>
  </div>
</ng-template>

<!-- 非粘性详情 -->
<ng-template #nonStickPopup>
  <div class="popup-common standard-popup">
    <div class="title">{{ 'bal_det' | translate }}</div>
    <div class="popup-item">
      {{ 'wallet_balance' | translate }}:
      <p class="main-color">
        {{ renderNonStickyDetails()?.balance || 0 | currencyValue: renderNonStickyDetails()?.currency || 'USDT' }}
        {{ renderNonStickyDetails()?.currency || 'USDT' }}
      </p>
    </div>
    <div class="popup-item" *ngIf="renderNonStickyDetails()?.nsSlotGame">
      {{ 'casino_bonus' | translate }}:
      <p class="main-color">
        {{
          renderNonStickyDetails()?.nsSlotGame?.balance || 0
            | currencyValue: renderNonStickyDetails()?.nsSlotGame?.currency || 'USDT'
        }}
        {{ renderNonStickyDetails()?.nsSlotGame?.currency || 'USDT' }}
      </p>
    </div>
    <div class="popup-item" *ngIf="renderNonStickyDetails()?.nsLiveCasino">
      {{ 'live_casino_bonus' | translate }}:
      <p class="main-color">
        {{
          renderNonStickyDetails()?.nsLiveCasino?.balance || 0
            | currencyValue: renderNonStickyDetails()?.nsLiveCasino?.currency || 'USDT'
        }}
        {{ renderNonStickyDetails()?.nsLiveCasino?.currency || 'USDT' }}
      </p>
    </div>
    <customize-button class="close-btn" width="100%" type="primary" size="large" (onClick)="closeDialog.close()">{{
      'confirm_button' | translate
    }}</customize-button>
  </div>
</ng-template>
